import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const ModelSelector = ({ models, value, onChange, disabled }) => {
  const [open, setOpen] = useState(false);
  const current = models.find((m) => m.key === value) || models[0];
  if (!current) return null;
  return (
    <div className="relative" data-testid="model-selector">
      <button
        type="button"
        onClick={() => !disabled && setOpen((o) => !o)}
        disabled={disabled}
        className="flex items-center gap-2 text-sm text-[#56534A] hover:text-[#1A1814] transition-colors disabled:opacity-50"
        data-testid="model-selector-trigger"
      >
        <span className="font-serif-display italic">{current.label}</span>
        <ChevronDown size={14} strokeWidth={1.5} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && !disabled && (
        <div
          className="absolute right-0 mt-2 w-48 bg-white border border-[#DDD9CF] z-30"
          onMouseLeave={() => setOpen(false)}
        >
          {models.map((m) => (
            <button
              key={m.key}
              type="button"
              onClick={() => {
                onChange(m.key);
                setOpen(false);
              }}
              className={`w-full text-left px-4 py-3 text-sm border-b border-[#DDD9CF] last:border-b-0 transition-colors ${
                m.key === value ? "text-[#C4521E]" : "text-[#1A1814] hover:bg-[#F9F7F3]"
              }`}
              data-testid={`model-option-${m.key}`}
            >
              {m.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
